// @vue/component
export default {
  name: 'star-rate',

  props: {
    value: { type: [Number, String] },
    name: { type: String, default: 'rate' },
    length: { type: Number },
    showcount: { type: Boolean },
    required: { type: Boolean },
    ratedesc: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {
      over: 0,
      rate: 0,
    };
  },

  methods: {
    onOver(index) {
      if (!this.readonly) {
        this.over = index;
      }
    },
    onOut() {
      if (!this.readonly) {
        this.over = this.rate;
      }
    },
    setRate(index) {
      if (this.readonly) {
        return false;
      }
      this.$emit('before-rate', this.rate);
      this.rate = index;
      this.$emit('input', this.rate);
      this.$emit('after-rate', this.rate);
    },
    isFilled(index) {
      return index <= this.over;
    },
    isEmpty(index) {
      return index > this.over || (!this.value && !this.over);
    },
  },

  created() {
    if (this.value >= this.length) {
      this.value = this.length;
    } else if (this.value < 0) {
      this.value = 0;
    }
    this.rate = this.value;
    this.over = this.value;
  },

  watch: {
    value: function (newValue) {
      this.rate = newValue;
    },
  },
};
